import { forwardRef } from "react";
import ReactMarkdown from "react-markdown";
import { cn } from "../lib/utils";
import { P } from "./p";

interface ContentfulTextProps {
  content: string;
  className?: string;
  ulClassName?: string;
  aClassName?: string;
  pClassName?: string;
}

/**
 * Contentful can have rich text in a string. Style it here like RichText
 */
const ContentfulText = forwardRef<HTMLDivElement, ContentfulTextProps>(
  ({ content, className, ulClassName, pClassName }, ref) => {
    return (
      <div ref={ref} className={cn(className)}>
        <ReactMarkdown
          components={{
            p: ({ children }) => (
              <P className={cn("mb-4", pClassName)}>{children}</P>
            ),
            ul: ({ children }) => (
              <ul className={cn("ml-4 list-disc", ulClassName)}>{children}</ul>
            ),
          }}
        >
          {content}
        </ReactMarkdown>
      </div>
    );
  },
);

ContentfulText.displayName = "ContentfulText";

export { ContentfulText };
